// client/src/config/banksData.js
// File di configurazione per i dati delle banche non di relazione

export const BANKS_DATA = {
  'ViViBanca Spa': {
    name: 'ViViBanca',
    description: {
      it: "ViViBanca S.p.A. è un gruppo bancario italiano con sede a Torino, attivo su tutto il territorio nazionale attraverso una rete capillare di filiali, agenti e canali digitali. Specializzata nel credito al consumo e nella cessione del quinto dello stipendio e della pensione, ViViBanca ha ampliato la propria operatività verso il segmento delle piccole e medie imprese, offrendo soluzioni di finanziamento e prodotti di raccolta ad alto rendimento destinati a questo segmento. ViViBanca S.p.A. aderisce al Fondo Interbancario di Tutela dei Depositi.",
      en: "ViViBanca S.p.A. is an Italian banking group headquartered in Turin, operating throughout the national territory through a widespread network of branches, agents, and digital channels. Specialized in consumer credit and salary and pension assignment loans, ViViBanca has expanded its operations toward the small and medium-sized enterprise segment, offering financing solutions and high-yield deposit products targeted at this segment. ViViBanca S.p.A. is a member of the Interbank Deposit Protection Fund."
    },
    dataDate: "31/12/2025",
    listed: false,
    cet1: "13,0%",
    tcr: "17,3%",
    totalAssets: "€1.886 milioni",
    totalDeposits: "€1.166 milioni",
    equity: "€108 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
  
 'Banca Privata Leasing Spa': {
    name: 'Banca Privata Leasing Spa',
    description: {
      it: "Attiva dal 1987 e con sede a Reggio Emilia, Banca Privata Leasing S.p.A. è la capogruppo del Gruppo Banca Privata Leasing, nato a seguito dell’acquisizione delle società ADV Finance, Procredit e ADV Family. Il Gruppo ha radici storiche legate a prodotti e servizi dedicati alle imprese, con focus particolare su leasing e finanziamenti. Grazie alle acquisizioni, il Gruppo ha rafforzato l’offerta dei propri servizi destinati al mercato retail, per esempio nella cessione del quinto. La banca è attiva sulla raccolta del risparmio tramite conti deposito destinati ad imprese e privati. Banca Privata Leasing aderisce al Fondo Interbancario di Tutela dei Depositi.",
      en: "Active since 1987 and headquartered in Reggio Emilia, Banca Privata Leasing S.p.A. is the parent company of the Banca Privata Leasing Group, established following the acquisition of ADV Finance, Procredit, and ADV Family. The Group has historical roots linked to products and services dedicated to businesses, with a particular focus on leasing and financing. Thanks to the acquisitions, the Group has strengthened its service offerings for the retail market, for example in salary-backed loans (cessione del quinto). The bank is active in savings collection through deposit accounts for businesses and individuals. Banca Privata Leasing is a member of the Interbank Deposit Protection Fund.",
    },
    dataDate: "31/12/2023",
    listed: false,
    cet1: "16,74%",
    tcr: "17,35%",
    totalAssets: "€762 milioni",
    totalDeposits: "€520 milioni",
    equity: "€50 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },

  'Allianz Bank Financial Advisors': {
    name: 'Allianz Bank Financial Advisors',
    description: {
      it: "Allianz Bank Financial Advisors S.p.A. è la banca rete italiana del Gruppo Allianz. Da oltre 50 anni si impegna nel soddisfare la clientela privata interessata ai servizi di investimento, posizionandosi tra le prime banche del suo settore in Italia per patrimonio in gestione. Una realtà solida e in costante crescita il cui azionista di riferimento, Allianz SE, è una delle più forti comunità finanziarie al mondo e detiene una solidità certificata dal rating AA dell’agenzia Standard & Poor’s, con outlook stabile dal 2007.",
      en: "Allianz Bank Financial Advisors S.p.A. is the Italian network bank of the Allianz Group. For over 50 years, it has been committed to meeting the needs of private clients interested in investment services, positioning itself among the leading banks in its sector in Italy in terms of assets under management. It is a solid and steadily growing institution whose main shareholder, Allianz SE, is one of the strongest financial groups in the world and boasts financial strength certified by an AA rating from Standard & Poor’s, with a stable outlook since 2007.",
    },
    dataDate: "31/12/2025",
    listed: false,
    cet1: "14,5%",
    tcr: "17%",
    totalAssets: "€11,2 miliardi",
    totalDeposits: "€9,6 miliardi",
    equity: "€664 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
  'Banca Partner 1': {
    name: 'Banca Partner 1',
    description: {
      it: "Banca Partner 1 è nata nel 1990 a Milano. La banca ha radici storiche ed opera nel mercato europeo.",
      en: "Allianz Bank Financial Advisors S.p.A. is the Italian network bank of the Allianz Group. For over 50 years, it has been committed to meeting the needs of private clients interested in investment services, positioning itself among the leading banks in its sector in Italy in terms of assets under management. It is a solid and steadily growing institution whose main shareholder, Allianz SE, is one of the strongest financial groups in the world and boasts financial strength certified by an AA rating from Standard & Poor’s, with a stable outlook since 2007.",
    },
    dataDate: "31/12/2024",
    listed: false,
    cet1: "17,5%",
    tcr: "21%",
    totalAssets: "€10,7 miliardi",
    totalDeposits: "€9,1 miliardi",
    equity: "€578 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
};

// Funzione helper per ottenere i dati di una banca
export const getBankData = (bankName, language = 'it') => {
  let bankData = null;
  
  // Cerca esattamente il nome
  if (BANKS_DATA[bankName]) {
    bankData = BANKS_DATA[bankName];
  } else {
    // Cerca case-insensitive
    const bankNameLower = bankName.toLowerCase();
    const foundKey = Object.keys(BANKS_DATA).find(
      key => key.toLowerCase() === bankNameLower
    );
    
    if (foundKey) {
      bankData = BANKS_DATA[foundKey];
    }
  }
  
  // Se la banca è stata trovata e ha descrizioni multilingua
  if (bankData && typeof bankData.description === 'object') {
    return {
      ...bankData,
      description: bankData.description[language] || bankData.description.it
    };
  }
  
  return bankData;
};

// Funzione per verificare se una banca è configurata
export const isBankConfigured = (bankName) => {
  return getBankData(bankName) !== null;
};